import { CURRENCY } from "constants/currencies";

import type { Currency } from "models/Currency";

export function isAUD(currency?: Currency) {
  return currency?.id === CURRENCY.AUD;
}
